import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Cookies from 'js-cookie';
import { getClient } from '@chegg/rio-sdk-web';
import { EventTypes, recordEvents } from "../../utils/newRelic/newRelicEvents";
import { viewNameDictionary } from "./rio.const";
var viewVersion = undefined;
export function getRioClient() {
  return getClient();
}
export async function sendRioEvent(type, data) {
  try {
    await getRioClient().sendEvent({
      type: type,
      data: data,
      eventVersion: 3
    });
  } catch (error) {
    recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
      type: type,
      data: data,
      error: error
    }));
  }
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}
export function componentViewEvent(data, viewName, uuid) {
  updateRioState({
    cheggUuid: uuid,
    view: {
      view_name: viewName,
      view_version: getViewVersion()
    }
  });
  return sendRioEvent('clickstream_component_view', data);
}
export function interactionRioEvent(data, viewName, uuid) {
  updateRioState({
    cheggUuid: uuid,
    view: {
      view_name: viewName,
      view_version: getViewVersion()
    }
  });
  return sendRioEvent('clickstream_interaction', data);
}
export function getViewVersion() {
  if (!viewVersion) {
    viewVersion = Cookies.get('chegg_web_cbr_three_dot_o') && Cookies.get('chegg_web_cbr_three_dot_o') === 'enabled' ? 'uae 1.0' : '';
  }
  return viewVersion;
}
export function getViewName(route) {
  return viewNameDictionary[route];
}

// Helper functions to keep components clean

// Click events
export function interactionMfaByApp(uuid) {
  interactionRioEvent({
    eventname: 'select verify with app',
    interaction: {
      element: {
        name: 'verify with app',
        region_name: 'mfa verification method modal',
        type: 'button'
      },
      type: 'select'
    }
  }, 'mfa verification method modal', uuid);
}
export function interactionMfaByEmail(uuid) {
  interactionRioEvent({
    eventname: 'select email code',
    interaction: {
      element: {
        name: 'email code',
        region_name: 'verification method modal',
        type: 'button'
      },
      type: 'select'
    }
  }, 'verification method modal', uuid);
}
export function interactionRioEventCloseModal(viewName, uuid) {
  interactionRioEvent({
    eventname: 'select dismiss',
    interaction: {
      element: {
        name: 'dismiss',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, viewName, uuid);
}
export function interactionBackButtonModal(viewName, uuid) {
  interactionRioEvent({
    eventname: 'select back',
    interaction: {
      element: {
        name: 'back',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, viewName, uuid);
}
export function interactionResend(viewName, uuid) {
  interactionRioEvent({
    eventname: 'select resend',
    interaction: {
      element: {
        name: 'resend',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, viewName, uuid);
}
export function interactionVerifyDifferentWay(viewName, uuid) {
  interactionRioEvent({
    eventname: 'select try verify again',
    interaction: {
      element: {
        name: 'try verify again',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, 'select try verify again', uuid);
}

// View events
export function componentViewEventByViewName(viewName, uuid) {
  componentViewEvent({
    eventname: "component ".concat(viewName),
    component_view: {
      component: {
        name: viewName,
        type: 'component'
      }
    }
  }, viewName, uuid);
}
export function componentViewEventTimeout(viewName, uuid) {
  componentViewEvent({
    eventname: "component mfa error modal",
    component_view: {
      component: {
        name: 'mfa error modal',
        value: 'qr code sent timeout',
        text: viewName,
        type: 'component'
      }
    }
  }, viewName, uuid);
}
export function componentViewEventGeneralError(viewName, title, uuid) {
  var _getRioClient$stateMa;
  var previousViewName = (_getRioClient$stateMa = getRioClient().stateManager._state) === null || _getRioClient$stateMa === void 0 || (_getRioClient$stateMa = _getRioClient$stateMa.viewPrevious) === null || _getRioClient$stateMa === void 0 ? void 0 : _getRioClient$stateMa.view_name;
  componentViewEvent({
    eventname: "component ".concat(viewName),
    component_view: {
      component: {
        name: viewName,
        type: 'component',
        value: title,
        text: title
      }
    }
  }, previousViewName, uuid);
}
export function componentViewEventFeedbackModal(viewName, title, uuid) {
  componentViewEvent({
    eventname: "component ".concat(viewName),
    component_view: {
      component: {
        name: viewName,
        type: 'component',
        text: title
      }
    }
  }, viewName, uuid);
}
export function componentViewEventAppDeclined(viewName, title, uuid) {
  componentViewEvent({
    eventname: 'component mfa error modal',
    component_view: {
      component: {
        name: 'mfa error modal',
        type: 'component',
        text: title,
        value: 'unable to verify info'
      }
    }
  }, viewName, uuid);
}
export function componentViewEventPx(viewName, uuid) {
  var _getRioClient$stateMa2;
  var previousViewName = (_getRioClient$stateMa2 = getRioClient().stateManager._state) === null || _getRioClient$stateMa2 === void 0 || (_getRioClient$stateMa2 = _getRioClient$stateMa2.viewPrevious) === null || _getRioClient$stateMa2 === void 0 ? void 0 : _getRioClient$stateMa2.view_name;
  componentViewEvent({
    eventname: "component ".concat(viewName),
    component_view: {
      component: {
        name: viewName,
        type: 'component',
        value: viewName
      }
    }
  }, previousViewName, uuid);
}